// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".center-input-text input[data-v-69bfa0e4]{text-align:center}@media only screen and (max-width:930px){.stack-on-mobile[data-v-69bfa0e4]{flex-direction:column}.stack-on-mobile button[data-v-69bfa0e4]{width:100%;border-top-left-radius:0;border-top-right-radius:0;border-bottom-left-radius:4px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
